import Footer from "../core/common/footer/Footer";

const faqData = [
  {
    id: 1,
    question: "What documents are required for Identity Verification?",
    answer:
      "You may be required to upload certain documents or provide additional information depending on the verification checks assigned to you by your organization. Please follow the instructions displayed in each verification step.",
  },
  {
    id: 2,
    question: "Can I save my progress and complete the form later?",
    answer:
      "Yes. Click the Save button to securely save your progress. You can log in later and continue from where you left off until you submit the verification.",
  },
  {
    id: 3,
    question: "Can I edit my information after submitting?",
    answer:
      "No. Once you submit a verification form, the information becomes read-only. Please review all details carefully before submitting.",
  },
  {
    id: 4,
    question: "Why am I asked to upload supporting documents?",
    answer:
      "Supporting documents help our verification team validate the information you have provided and speed up the background verification process.",
  },
  {
    id: 5,
    question: "What file formats are supported?",
    answer:
      "Most document uploads support PDF, JPG, JPEG and PNG files. Individual upload fields may have different size and format restrictions.",
  },
  {
    id: 6,
    question: "How can I track my verification status?",
    answer:
      "You can monitor the status of each verification check from the Case Summary page after logging into the Candidate Portal.",
  },
  {
    id: 7,
    question: "How long does the verification process take?",
    answer:
      "Verification timelines vary depending on the type of checks initiated and the responsiveness of third-party sources (e.g., universities, employers). Most checks are completed within a few business days, but some may take longer.",
  },
  {
    id: 8,
    question: "What happens if I upload the wrong document by mistake?",
    answer:
      "If you haven't submitted the form yet, you can remove the incorrect document and upload the correct one. If you've already submitted, please contact your organization's HR or support team for assistance.",
  },
  {
    id: 9,
    question: "Is my personal information kept secure?",
    answer:
      "Yes. All information and documents you submit are encrypted and stored securely, and are only accessible to authorized verification personnel for the purpose of completing your background check.",
  },
  {
    id: 10,
    question:
      "What should I do if I face a technical issue while submitting the form?",
    answer:
      "Try refreshing the page or using a different browser. If the issue persists, please reach out to our support team with a screenshot of the error for faster resolution.",
  },
  {
    id: 11,
    question: "Will I be notified once my verification is complete?",
    answer:
      "Yes. You will receive an email or portal notification once your verification status is updated. You can also check the Case Summary page anytime for the latest status.",
  },
];

const Faq = () => {
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="col-lg-12">
          <div className="card border">
            <div className="card-header bg-white border-bottom text-center">
              <h4 className="mb-1 fw-bold">
                <i className="bi bi-question-circle-fill text-primary me-2"></i>
                Frequently Asked Questions
              </h4>

              <p className="text-muted mb-0">
                Find answers to common questions regarding your Background
                Verification.
              </p>
            </div>

            <div className="card-body">
              <div className="accordion" id="faqAccordion">
                {faqData.map((faq) => (
                  <div
                    className="accordion-item border rounded mb-2"
                    key={faq.id}
                  >
                    <h2 className="accordion-header" id={`heading${faq.id}`}>
                      <button
                        className={`accordion-button text-dark ${
                          faq.id !== 1 ? "collapsed" : ""
                        } fw-medium`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${faq.id}`}
                        aria-expanded={faq.id === 1}
                      >
                        {faq.question}
                      </button>
                    </h2>

                    <div
                      id={`collapse${faq.id}`}
                      className={`accordion-collapse collapse ${
                        faq.id === 1 ? "show" : ""
                      }`}
                      aria-labelledby={`heading${faq.id}`}
                    >
                      <div className="accordion-body text-dark">
                        {faq.answer}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Faq;
